export default __webpack_public_path__ + "static/media/editor-toolbar-icon-underline.a1b5e620.svg";